import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const CommentsSection = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: ${({ theme: { token } }) => token.marginLG}px;

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .label {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    font-family: ${({ theme: { token } }) => token.fontFamily};
    line-height: ${({ theme: { token } }) => token.lineHeight};
  }
`;

export const CommonInput = styled.input<{ theme: { token: GlobalToken } }>`
  height: 40px;
  padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.padding}px;
  background: ${({ theme: { token } }) => token.colorBgContainer};
  border: 1px solid ${({ theme: { token } }) => token.colorBorder};
  border-radius: ${({ theme: { token } }) => token.borderRadius}px;
  color: ${({ theme: { token } }) => token.colorText};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  font-family: ${({ theme: { token } }) => token.fontFamily};
  width: 100%;

  &::placeholder {
    color: ${({ theme: { token } }) => token.colorTextPlaceholder};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme: { token } }) => token.colorPrimary};
  }

  &:disabled {
    background: ${({ theme: { token } }) => token.colorBgContainerDisabled};
    cursor: not-allowed;
    color: ${({ theme: { token } }) => token.colorTextDisabled};
  }
`;

export const Description = styled.div<{ theme: { token: GlobalToken } }>`
  color: ${({ theme: { token } }) => token.colorText};
  font-size: ${({ theme: { token } }) => token.fontSize}px;
  font-family: ${({ theme: { token } }) => token.fontFamily};
  line-height: ${({ theme: { token } }) => token.lineHeight};

  .subtitle {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    font-family: ${({ theme: { token } }) => token.fontFamily};
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    line-height: ${({ theme: { token } }) => token.lineHeight};
  }
`;
